export default __webpack_public_path__ + "static/media/appleStore.a0def591.png";